import React from 'react';

const ErrorPage = () => {
  return (
    <div className='p-5 error w-100'>
      <h1 className='display-5 mb-4'>Nothing found!</h1>
      <p className='lead'>
        We are sorry, but currently search options are limited. You can take a
        look at all the available search keywords below and try again.
      </p>
      <div className='btn-group dropend mt-3'>
        <button type='button' className='btn btn-info text-white shadow-sm'>
          Available Search
        </button>
        <button
          type='button'
          className='btn btn-info dropdown-toggle dropdown-toggle-split shadow-sm'
          data-bs-toggle='dropdown'
          aria-expanded='false'
        >
          <span className='visually-hidden'>Toggle Dropright</span>
        </button>
        <ul
          className='dropdown-menu dropdown-menu-dark shadow-sm'
          aria-labelledby='dropdownMenuButton2'
        >
          <li className='dropdown-item'>All</li>
          <li className='dropdown-item'>Codechef</li>
          <li className='dropdown-item'>Codeforces</li>
          <li className='dropdown-item'>Leetcode</li>
          <li className='dropdown-item'>HackerEarth</li>
          <li className='dropdown-item'>HackerRank</li>
          <li className='dropdown-item'>TopCoder</li>
          <li className='dropdown-item'>AtCoder</li>
          <li className='dropdown-item'>KickStart</li>
        </ul>
      </div>
    </div>
  );
};

export default ErrorPage;
